module.exports = __webpack_public_path__ + "static/media/14.5bad3d65.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/units/14.svg
// module id = 386
// module chunks = 14